//core
import React, {useCallback, useState} from "react";
import { useTranslation } from "react-i18next";
import arePropsEqual from "react-fast-compare";
import {useSelector} from "react-redux";

//components
import {useWebhooksReport} from "../../../../../../store/admin/reports/webhooks_report/useWebhooksReport";
import {selectBulkResendPostbackIsFetching} from "../../../../../../store/admin/reports/webhooks_report/selectors";
import {RemoveRedEye, Replay} from "@mui/icons-material";
import ActionIconButton from "../../../../../UI/Buttons/ActionIconButton";
import PermissionsWrapper from "../../../../../common/PermissionsWrapper";
import MuiModal from "../../../../../UI/MuiModal";
import DetailsWebhook from "../DetailsWebhook";

//utils
import { canWebhookResend } from "../../utils";


export interface ITableActions {
  id: number;
  data: any;
}

const TableActions: React.FC<ITableActions> = (props): JSX.Element => {
  const { t } = useTranslation();

  const { id, data } = props;

  const { bulkResendPostback } = useWebhooksReport();
  const isResendFetching = useSelector(selectBulkResendPostbackIsFetching);

  const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);

  const canResend = canWebhookResend(data.created_at, data.status);

  const handleToggleDetailsModal = useCallback((state: boolean) => {
    setShowDetailsModal(state);
  }, [setShowDetailsModal]);

  const handleResendPostback = useCallback(() => {
    bulkResendPostback({ taskIds: [id] });
  }, [bulkResendPostback, id]);

  return (

    <>
      <PermissionsWrapper permissions={["api2.admin.webhookstaskscontroller.resend"]}>
        <ActionIconButton
          text={t("admin.reports.webhooks_report.resendSinglePostback.tooltip")}
          icon={<Replay fontSize="small" color='primary' />}
          disabled={!canResend || isResendFetching}
          onClick={handleResendPostback}
        />
      </PermissionsWrapper>

      <ActionIconButton
        text={t("common.buttons.view")}
        icon={<RemoveRedEye fontSize="small" color='primary' />}
        onClick={() => handleToggleDetailsModal(true)}
      />

      <MuiModal
        width={1072}
        open={showDetailsModal}
        closeOnOutside={false}
        setToggleModal={handleToggleDetailsModal}
      >
        <DetailsWebhook
          id={id}
          data={data}
          onClose={handleToggleDetailsModal}
        />
      </MuiModal>
    </>
  );
};

export default React.memo(TableActions, arePropsEqual);
